(() => {
  if (customElements.get('hd-announcement-bar')) {
    return;
  }

  class HdAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.onPreviousClick = this.showPrevious.bind(this);
      this.onNextClick = this.showNext.bind(this);
      this.onMouseEnter = this.stop.bind(this);
      this.onMouseLeave = this.start.bind(this);
      this.onFocusIn = this.stop.bind(this);
      this.onFocusOut = this.start.bind(this);
      this.onViewportChange = this.handleViewportChange.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-hd-announcement-item]'));
      this.previousButton = this.querySelector('[data-hd-announcement-previous]');
      this.nextButton = this.querySelector('[data-hd-announcement-next]');
      this.interval = Number(this.dataset.interval) || 4000;
      this.autoplay = this.dataset.autoplay === 'true';

      if (this.items.length <= 1) {
        this.toggleControls(false);
        return;
      }

      this.previousButton?.addEventListener('click', this.onPreviousClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.desktopQuery.addEventListener('change', this.onViewportChange);

      this.update();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.previousButton?.removeEventListener('click', this.onPreviousClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      this.desktopQuery.removeEventListener('change', this.onViewportChange);
    }

    start() {
      if (!this.autoplay || this.prefersReducedMotion || this.desktopQuery.matches || this.items.length <= 1) {
        return;
      }

      this.stop();
      this.timer = window.setInterval(() => this.showNext(), this.interval);
    }

    stop() {
      if (!this.timer) {
        return;
      }

      window.clearInterval(this.timer);
      this.timer = null;
    }

    showPrevious() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.update();
      this.start();
    }

    showNext() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.update();
      this.start();
    }

    handleViewportChange() {
      this.stop();
      this.update();
      this.start();
    }

    update() {
      this.items.forEach((item, index) => {
        const isActive = this.desktopQuery.matches ? index < 4 : index === this.currentIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        item.tabIndex = isActive && item.hasAttribute('href') ? 0 : -1;
      });
    }

    toggleControls(isVisible) {
      this.previousButton?.toggleAttribute('hidden', !isVisible);
      this.nextButton?.toggleAttribute('hidden', !isVisible);
    }
  }

  customElements.define('hd-announcement-bar', HdAnnouncementBar);
})();
